import { ref, watch } from 'vue'
import client from '@/composables/homebaseClient'

export default function useHomebaseHouseholds(initialParams = {}) {
    const households = ref([])
    const householdHistory = ref(null)
    const loading = ref(false)
    const historyLoading = ref(false)
    const error = ref(null)

    const params = ref({
        community: '',
        status: '',
        hasContainer: '',
        limit: 100,
        sortBy: 'createdAt',
        sortDir: 'desc',
        ...initialParams
    })

    const toQuery = () => {
        const q = new URLSearchParams()
        if (params.value.community) q.set('community', params.value.community)
        if (params.value.status) q.set('status', params.value.status)
        if (params.value.hasContainer !== '') q.set('hasContainer', params.value.hasContainer)
        if (params.value.limit) q.set('limit', String(params.value.limit))
        if (params.value.sortBy) q.set('sortBy', params.value.sortBy)
        if (params.value.sortDir) q.set('sortDir', params.value.sortDir)
        return q.toString() ? `?${q.toString()}` : ''
    }

    const fetchHouseholds = async () => {
        loading.value = true
        error.value = null
        try {
            const res = await client.get(`/households${toQuery()}`)
            households.value = Array.isArray(res.data) ? res.data : []
        } catch (err) {
            error.value = err.detail || 'Failed to load households'
        } finally {
            loading.value = false
        }
    }

    const fetchHouseholdHistory = async (householdId) => {
        historyLoading.value = true
        try {
            const res = await client.get(`/households/${householdId}/history`)
            householdHistory.value = res.data
            return res.data
        } catch (err) {
            error.value = err.detail || 'Failed to load household history'
            throw err
        } finally {
            historyLoading.value = false
        }
    }

    const getHousehold = async (householdId) => {
        try {
            const res = await client.get(`/households/${householdId}`)
            return res.data
        } catch (err) {
            error.value = err.detail || 'Failed to load household'
            throw err
        }
    }

    // Auto-fetch when params change
    watch(params, fetchHouseholds, { deep: true })

    return {
        households,
        householdHistory,
        loading,
        historyLoading,
        error,
        params,
        fetchHouseholds,
        fetchHouseholdHistory,
        getHousehold
    }
}
